import {
  Grid,
  GridItem,
  SelectInputField,
  Text,
  TextareaField,
} from "@certn/cascadia-react";
import { Field } from "formik";
import { useTranslation } from "react-i18next";
import { Item } from "react-stately";

import { FormModal } from "./FormModal";
import { HelpPrivacyConsent } from "./HelpPrivacyConsent";
import { useTopicList } from "./utils";

interface GeneralFeedbackModalContentsProps {
  handleSubmit: () => void;
  close: () => void;
}

export function GeneralFeedbackModalContents(
  props: GeneralFeedbackModalContentsProps
) {
  const { handleSubmit, close } = props;
  const topicList = useTopicList();

  const { t } = useTranslation();
  return (
    <FormModal
      title={t("General feedback")}
      onSubmit={handleSubmit}
      onCancel={close}
      variant="success"
      continueText={t("Submit")}
    >
      <Grid form>
        <GridItem>
          <Text style="global/body-primary">
            {t(
              "We want to hear the good, the bad, and any ideas for improving the experience."
            )}
          </Text>
        </GridItem>
        <GridItem>
          <Field
            name="topic"
            label={t("Topic")}
            as={SelectInputField}
            placeholder={t("Please select")}
            isRequired
            testID="general-feedback-modal-topic-select"
          >
            {topicList?.map((topic) => (
              <Item key={topic.value}>{topic.name}</Item>
            ))}
          </Field>
        </GridItem>
        <GridItem>
          <Field
            name="message"
            label={t("Message")}
            as={TextareaField}
            isRequired
            testID="general-feedback-modal-message-input"
          />
        </GridItem>
        <GridItem>
          <HelpPrivacyConsent />
        </GridItem>
      </Grid>
    </FormModal>
  );
}
